import { createServerFn } from "@tanstack/react-start";

import type { ProxyCheckerPageContent } from "@/content/proxyCheckerPage";
import { contentSource } from "@/content/source";

/**
 * The Proxy Checker page's content, at prerender. No committed copy stands
 * behind it: a page with no document is not found.
 */
export const proxyCheckerPageCms = createServerFn({ method: "GET" }).handler(
  async (): Promise<ProxyCheckerPageContent | null> =>
    (await contentSource()).loadProxyCheckerPage()
);
